export default {
  LOGIN: 'LOGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAIL: 'LOGIN_FAIL',
  LOGOUT: 'LOGOUT',
  SELECT_BOT: 'SELECT_BOT',
  LOADING: 'LOADING',
  CLEAR_LOADING: 'CLEAR_LOADING',
  SIDEBAR: 'SIDEBAR',
  SELECT_NEW_BOT: 'SELECT_NEW_BOT',
  UPDATE_SETTING: 'UPDATE_SETTING',
  UPDATE_WELCOME_MESSAGE: 'UPDATE_WELCOME_MESSAGE',
  UPDATE_MODAL_WELCOME: 'UPDATE_MODAL_WELCOME',
  SET_LANG: 'SET_LANG',
  UPDATE_ALERT: 'UPDATE_ALERT',
  SET_LIVECHAT_USERS: 'SET_LIVECHAT_USERS',
  SET_LIVECHAT_USER: 'SET_LIVECHAT_USER',
  SET_KETSHOP_TOKEN: 'SET_KETSHOP_TOKEN'
}



// WEBPACK FOOTER //
// ./src/store/config.js